/* global app */
app.controller('dialog_simpleTextLineCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', function ($rootScope, $scope, $http, NetworkService, MainService) {
        
        $rootScope.$on("ACSimpleTextLineDialog::open", function(e, d){
                $scope.parameters = d.parameters;
        })
        
        $rootScope.$on("ACSimpleTextLineDialog::getVal", function(){
                $rootScope.$emit("ACSimpleTextLineDialog::getValResponse", $scope.text);
        })
        $scope.text = "";
    }])